/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    Authenticated,
    GetRegisterParams,
    LoginTimeout,
    PostRegisterParams,
    SetPasswordData,
    Unauthenticated,
    UserView,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getRegister = (
    params: GetRegisterParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserView>> => {
    return axios.get(`/api/register`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetRegisterQueryKey = (params?: GetRegisterParams) => {
    return [`/api/register`, ...(params ? [params] : [])] as const;
};

export const getGetRegisterQueryOptions = <
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRegisterQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegister>>> = ({
        signal,
    }) => getRegister(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRegister>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRegisterQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRegister>>
>;
export type GetRegisterQueryError = AxiosError<unknown>;

export function useGetRegister<
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRegister>>,
                    TError,
                    Awaited<ReturnType<typeof getRegister>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegister<
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRegister>>,
                    TError,
                    Awaited<ReturnType<typeof getRegister>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegister<
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRegister<
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRegisterQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetRegisterSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRegisterQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegister>>> = ({
        signal,
    }) => getRegister(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getRegister>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRegisterSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRegister>>
>;
export type GetRegisterSuspenseQueryError = AxiosError<unknown>;

export function useGetRegisterSuspense<
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegisterSuspense<
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRegisterSuspense<
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRegisterSuspense<
    TData = Awaited<ReturnType<typeof getRegister>>,
    TError = AxiosError<unknown>,
>(
    params: GetRegisterParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRegister>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRegisterSuspenseQueryOptions(params, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postRegister = (
    setPasswordData: SetPasswordData,
    params: PostRegisterParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<Authenticated>> => {
    return axios.post(`/api/register`, setPasswordData, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getPostRegisterMutationOptions = <
    TError = AxiosError<Unauthenticated | LoginTimeout>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRegister>>,
        TError,
        { data: SetPasswordData; params: PostRegisterParams },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRegister>>,
    TError,
    { data: SetPasswordData; params: PostRegisterParams },
    TContext
> => {
    const mutationKey = ["postRegister"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRegister>>,
        { data: SetPasswordData; params: PostRegisterParams }
    > = (props) => {
        const { data, params } = props ?? {};

        return postRegister(data, params, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostRegisterMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRegister>>
>;
export type PostRegisterMutationBody = SetPasswordData;
export type PostRegisterMutationError = AxiosError<
    Unauthenticated | LoginTimeout
>;

export const usePostRegister = <
    TError = AxiosError<Unauthenticated | LoginTimeout>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRegister>>,
            TError,
            { data: SetPasswordData; params: PostRegisterParams },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postRegister>>,
    TError,
    { data: SetPasswordData; params: PostRegisterParams },
    TContext
> => {
    return useMutation(getPostRegisterMutationOptions(options), queryClient);
};
